import { Icons } from '@citygross/icons';
import React from 'react';
import { MainCategoryWrapper, HeaderText } from './MenuListItem.styles.js';

var MenuListHeader = function MenuListHeader(_a) {
  var onClick = _a.onClick,
      dropdownHeader = _a.dropdownHeader,
      mainCategorySelected = _a.mainCategorySelected,
      hoverBackground = _a.hoverBackground;
  return React.createElement(MainCategoryWrapper, {
    onClick: onClick,
    hoverBackground: hoverBackground
  }, React.createElement(HeaderText, null, dropdownHeader), !mainCategorySelected && React.createElement(Icons.ChevronRight, null));
};

export { MenuListHeader };